/* SPACES designer v3: WallArt / wall mural / wallpaper, AI or upload, orientation, resolution gate, wall mockup */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g,' ') + ' Ft'; }
  var DIM = { S: [30, 45], M: [50, 75], L: [60, 90], XL: [100, 150] }, STRIP = 58;
  var DEFOR = { falikep: 'portrait', fototapeta: 'landscape', tapeta: 'portrait' };
  function init() {
    var r = $('.sp-dz');
    if (!r || r.__d2) return;
    r.__d2 = 1;
    var T = r.dataset, qs = new URLSearchParams(location.search);
    var st = { line: 'falikep', mode: 'ai', or: { falikep: 'portrait', fototapeta: 'landscape', tapeta: 'square' }, img: null, cur: null, wallImg: '', prompt: '' };
    if (['falikep', 'fototapeta', 'tapeta'].indexOf(qs.get('line')) > -1) st.line = qs.get('line');
    if (['ai', 'upload'].indexOf(qs.get('mode')) > -1) st.mode = qs.get('mode');
    var pArt = $('[data-panel=art]', r), pWall = $('[data-panel=wall]', r);
    var sceneM = $('.sp-ps.mural', pWall), sceneP = $('.sp-ps.paper', pWall), tileCm = STRIP, mock = $('[data-wm]', pWall), wv = 'mock';
    function wallScene(img) {
      if (mock) mock.parentNode.hidden = wv !== 'mock';
      [sceneM, sceneP].forEach(function (sc) {
        if (!sc) return;
        var on = sc === (st.line === 'tapeta' ? sceneP : sceneM); sc.parentNode.hidden = !(on && wv === 'room');
        var i = sc.querySelector('.i'); if (i) i.style.backgroundImage = img ? 'url("' + img + '")' : 'linear-gradient(135deg,#efe7da,#d9cdb9)';
        sc.style.setProperty('--tw', tileCm);
      });
    }
    var std = JSON.parse($('[data-gstd]', r).textContent || '[]'), ps = JSON.parse($('[data-gps]', r).textContent || '[]'), strips = JSON.parse($('[data-gstrip]', r).textContent || '[]');
    var wadd = $('[data-wadd]', pWall), wmsg = $('[data-wmsg]', pWall), cur = null, qty = 2;

    // ---------- show / hide ----------
    function show() {
      var wall = st.line !== 'falikep';
      pArt.hidden = wall; pWall.hidden = !wall;
      $$('[data-line]', r).forEach(function (b) { b.classList.toggle('on', b.dataset.line === st.line); });
      $$('[data-mode]', r).forEach(function (b) { b.classList.toggle('on', b.dataset.mode === st.mode); });
      $$('[data-src-ai]', r).forEach(function (n) { n.hidden = st.mode !== 'ai'; });
      $$('[data-src-up]', r).forEach(function (n) { n.hidden = st.mode !== 'upload'; });
      $('[data-sub=mural]', pWall).hidden = st.line !== 'fototapeta';
      var ow = $('[data-or-wall]', pWall); if (ow) ow.hidden = st.line === 'fototapeta';
      $$('[data-or=square]', pWall).forEach(function (n) { n.hidden = st.line !== 'tapeta'; });
      $$('[data-wallopts]', pWall).forEach(function (n) { n.hidden = st.line !== 'tapeta'; });
      $$('[data-mnote]', r).forEach(function (n) { n.hidden = st.line !== 'fototapeta'; });
      $('[data-sub=paper]', pWall).hidden = st.line !== 'tapeta';
      if (mock) mock.dataset.kind = st.line === 'tapeta' ? 'paper' : 'mural';
      orientUI(); wallUp(); qual();
    }
    $$('[data-wv]', pWall).forEach(function (b) {
      b.addEventListener('click', function () {
        wv = b.dataset.wv;
        $$('[data-wv]', pWall).forEach(function (x) { x.classList.toggle('on', x === b); });
        wallUp();
      });
    });
    // default wall for the mural: 400 x 270 cm, the customer can change it
    var dmw = $('[data-mw]', pWall), dmh = $('[data-mh]', pWall);
    if (dmw && !dmw.value) dmw.value = 400; if (dmh && !dmh.value) dmh.value = 270;
    $$('[data-line]', r).forEach(function (b) { b.addEventListener('click', function () { st.line = b.dataset.line; show(); applyImage(); }); });
    $$('[data-mode]', r).forEach(function (b) { b.addEventListener('click', function () { st.mode = b.dataset.mode; show(); }); });

    // ---------- orientation ----------
    function orientUI() {
      var o = st.or[st.line];
      $$('[data-or]', r).forEach(function (b) { b.classList.toggle('on', b.dataset.or === o); });
      r.__or = st.or.falikep;
      $$('.sp-scene', pArt).forEach(function (s) { s.classList.toggle('land', st.or.falikep === 'landscape'); if (window.__spFit) window.__spFit(s); });
      var lab = $('.sp-dz-lab', pArt); if (lab) { var m = lab.textContent.match(/(\d+)\D+(\d+)/); if (m) { var a = +m[1], b = +m[2], L = st.or.falikep === 'landscape'; if (L ? a < b : a > b) lab.textContent = b + '×' + a + ' cm'; } }
    }
    $$('[data-or]', r).forEach(function (b) { b.addEventListener('click', function () { st.or[st.line] = b.dataset.or; orientUI(); qual(); if (r.__up) r.__up(); }); });

    // ---------- wall panel (mural / paper) ----------
    function mat() { var i = $('input[name=wlm]:checked', pWall); return i ? i.value : 'std'; }
    function plen() { var i = $('input[name=plen]:checked', pWall); return i ? +i.value : 300; }
    function setLen(l) { $$('input[name=plen]', pWall).forEach(function (i) { i.checked = +i.value === l; }); }
    function stripVar(len, t) { return window.__spRolls.vfor(strips, len, t || 0); }
    function sqx() { var c = $('[data-sqopt]', pWall); return c && c.checked && +T.sqp ? +T.sqp : 0; }
    function wallUp() {
      cur = null;
      var img = st.wallImg || '';
      if (st.line === 'fototapeta') {
        var w = parseFloat($('[data-mw]', pWall).value), h = parseFloat($('[data-mh]', pWall).value), tbm = $('[data-tiersm]', pWall), mrate = ps.length ? ps[0].price : 0;
        if (tbm) tbm.innerHTML = window.__spRolls.mtable(mrate, 0, money, T);
        if (window.__spWM && mock) window.__spWM(mock, { w: w >= 20 ? w : 400, h: h >= 20 ? h : 300, img: img });
        wallScene(img);
        var rmsg = $('[data-srcmsg]', pWall);
        if (st.cur === 'ai' && st.genRatio && w >= 1 && h >= 1 && Math.abs((w / h) / st.genRatio - 1) > 0.2) { rmsg.textContent = T.tRatio; rmsg.__ratio = 1; } else if (rmsg && rmsg.__ratio) { rmsg.textContent = ''; rmsg.__ratio = 0; }
        if (w >= 1 && h >= 1 && (w < 150 || h < 100)) { $('[data-marea]', pWall).textContent = '–'; $('[data-mtotal]', pWall).textContent = '–'; wadd.disabled = true; wadd.textContent = T.tEnter; wmsg.textContent = T.tMin; return; }
      if (!(w >= 1) || !(h >= 1)) { $('[data-marea]', pWall).textContent = '–'; $('[data-mtotal]', pWall).textContent = '–'; wadd.disabled = true; wadd.textContent = T.tEnter; return; }
        var a = w * h / 10000, n = Math.max(1, Math.ceil(a - 1e-9));
        $('[data-marea]', pWall).textContent = a.toFixed(2).replace('.', ',') + ' m² → ' + n + ' m²';
        if (tbm) tbm.innerHTML = window.__spRolls.mtable(mrate, n, money, T);
        wmsg.textContent = '';
        if (n > 60) { wadd.disabled = true; wadd.textContent = T.tEnter; wmsg.textContent = T.tBig; return; }
        var list = ps;
        for (var i = 0; i < list.length; i++) { if (list[i].title === n + ' m²') { cur = list[i]; break; } }
        if (!cur) { wadd.disabled = true; return; }
        $('[data-mtotal]', pWall).textContent = money(cur.price + sqx());
        wadd.disabled = !!r.__wblock; wadd.textContent = T.tAdd + ' · ' + money(cur.price + sqx());
      } else if (st.line === 'tapeta') {
        var RL = window.__spRolls, tr = RL.tier(qty, plen()), v = stripVar(plen(), tr), tb = $('[data-tiers]', pWall);
        if (tb) tb.innerHTML = RL.table(strips, plen(), qty, money, T);
        $('[data-q]', pWall).textContent = qty;
        var pw = parseFloat($('[data-pw]', pWall).value), ph = parseFloat($('[data-ph]', pWall).value);
        if (window.__spWM && mock) window.__spWM(mock, { w: pw >= 50 ? pw : 300, h: ph >= 50 ? ph : 250, img: img });
        wallScene(img);
        if (v) { cur = v; $('[data-ptotal]', pWall).textContent = money(v.price * qty + sqx()); wadd.disabled = !!r.__wblock; wadd.textContent = T.tAdd + ' · ' + money(v.price * qty + sqx()); }
      }
    }
    $$('input', pWall).forEach(function (i) { if (i.type === 'number' || i.type === 'radio') i.addEventListener(i.type === 'number' ? 'input' : 'change', function () { if (i.hasAttribute('data-pw') || i.hasAttribute('data-ph')) fromWall(); wallUp(); qual(); }); });
    function fromWall() {
      var w = parseFloat($('[data-pw]', pWall).value), h = parseFloat($('[data-ph]', pWall).value), need = $('[data-pneed]', pWall);
      wmsg.textContent = '';
      if (!(w >= 20) || !(h >= 20)) { need.textContent = ''; return; }
      var pl = window.__spRolls.plan(w, h);
      if (!pl.best) { need.textContent = ''; wmsg.textContent = T.tHigh; return; }
      qty = pl.best.qty; setLen(pl.best.len);
      need.textContent = T.tNeed + ': ' + pl.n + ' × ' + pl.best.len + ' cm' + (qty > pl.n ? ' (' + T.tRec + ': ' + qty + ')' : '');
    }
    var sqc = $('[data-sqopt]', pWall); if (sqc) sqc.addEventListener('change', wallUp);
    $('[data-qm]', pWall).addEventListener('click', function () { qty = Math.max(2, qty - 1); wallUp(); });
    $('[data-qp]', pWall).addEventListener('click', function () { qty = Math.min(99, qty + 1); wallUp(); });
    wadd.addEventListener('click', function () {
      if (!cur) return;
      var items, props = { 'Termékvonal': st.line === 'fototapeta' ? 'Fotótapéta' : 'Tapéta' };
      if (st.cur === 'up' && st.wallImg) props['Feltöltött kép'] = st.wallImg; else if (st.cur === 'ai' && st.wallImg) props['AI kép'] = st.wallImg;
      if (st.prompt) props['Leírás'] = st.prompt.slice(0, 200);
      if (st.line === 'tapeta') props['Minta mérete'] = tileCm + ' cm';
      if (st.line === 'fototapeta') {
        props['Szélesség'] = $('[data-mw]', pWall).value + ' cm'; props['Magasság'] = $('[data-mh]', pWall).value + ' cm'; props['Anyag'] = 'Nekoosa Peel&Stick™ Canvas falfólia'; props['Számolt terület'] = cur.title;
        items = [{ id: cur.id, quantity: 1, properties: props }];
      } else {
        props['Csík hossza'] = plen() + ' cm'; props['Mennyiségi kedvezmény'] = window.__spRolls.TIERS[window.__spRolls.tier(qty, plen())] + ' %'; props['Csík szélessége'] = '58 cm';
        var pw = $('[data-pw]', pWall).value, ph = $('[data-ph]', pWall).value; if (pw && ph) props['Fal'] = pw + ' × ' + ph + ' cm';
        items = [{ id: cur.id, quantity: qty, properties: props }];
      }
      var sq = $('[data-sqopt]', pWall); if (sq && sq.checked && T.sq) items = items.concat([{ id: +T.sq, quantity: 1 }]);
      wadd.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (x) { if (!x.ok) throw new Error('add'); location.href = T.cartUrl || '/cart'; })
        .catch(function () { wmsg.textContent = T.tErr; wadd.disabled = false; });
    });

    // ---------- AI (wall panel) ----------
    var wform = $('[data-wform]', pWall);
    if (wform) wform.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = wform.querySelector('input').value.trim(), msg = $('[data-srcmsg]', pWall), b = wform.querySelector('button');
      if (v.length < 3) return;
      st.prompt = v; clearUpload(true);
      if (!T.ai) { msg.textContent = T.tNoai; return; }
      b.disabled = true; msg.textContent = T.tGen;
      fetch(T.ai, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ prompt: v, kind: st.line === 'fototapeta' ? 'mural' : 'wallpaper', orientation: st.or[st.line], density: st.line === 'tapeta' && $('[data-density]', pWall) ? $('[data-density]', pWall).value : undefined, motif: st.line === 'tapeta' && $('[data-motif]', pWall) ? $('[data-motif]', pWall).value : undefined, wall: st.line === 'fototapeta' ? { w: parseFloat($('[data-mw]', pWall).value) || 400, h: parseFloat($('[data-mh]', pWall).value) || 270 } : undefined }) })
        .then(function (x) { return x.json().then(function (j) { return { ok: x.ok, j: j }; }); })
        .then(function (o) {
          if (!o.ok || !o.j.url) throw o.j || {};
          var im = new Image();
          im.onload = function () { st.wallImg = o.j.url; st.cur = 'ai'; st.genRatio = st.line === 'fototapeta' ? (parseFloat($('[data-mw]', pWall).value) || 400) / (parseFloat($('[data-mh]', pWall).value) || 270) : 0; msg.textContent = ''; b.disabled = false; wallUp(); qual(); };
          im.onerror = function () { b.disabled = false; msg.textContent = T.tAiErr; };
          im.src = o.j.url;
        })
        .catch(function (e2) { b.disabled = false; msg.textContent = e2 && e2.error === 'limit' ? T.tLimit : e2 && e2.error === 'daily' ? T.tDaily : e2 && e2.error === 'blocked' ? T.tBlocked : T.tAiErr; });
    });
    var aform = $('[data-dz-form]', pArt);
    if (aform) aform.addEventListener('submit', function () { st.cur = 'ai'; r.__block = false; clearUploadUI(); qual(); }, true);

    // ---------- upload ----------
    var epUp = T.ai ? T.ai.replace(/\/+$/, '') + '/upload' : '';
    function clearUploadUI() { $$('[data-uprev]', r).forEach(function (n) { n.hidden = true; }); $$('[data-file]', r).forEach(function (n) { n.value = ''; }); $$('[data-upmsg]', r).forEach(function (n) { n.textContent = ''; }); }
    function clearUpload(keepArt) { st.img = null; if (st.cur === 'up') st.cur = null; st.wallImg = st.cur === 'ai' ? st.wallImg : ''; r.__block = false; r.__wblock = false; clearUploadUI(); if (!keepArt && r.__clrImg) r.__clrImg(); wallUp(); qual(); }
    $$('[data-updel]', r).forEach(function (b) { b.addEventListener('click', function () { st.wallImg = ''; clearUpload(false); }); });
    $$('[data-drop]', r).forEach(function (d) { if (!epUp) d.hidden = true; });
    $$('[data-upnoep]', r).forEach(function (n) { n.hidden = !!epUp; });
    function handle(file) {
      if (!file) return;
      $$('[data-upmsg]', r).forEach(function (n) { n.textContent = ''; });
      if (['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type) < 0) { $$('[data-upmsg]', r).forEach(function (n) { n.textContent = T.tUpType; }); return; }
      if (file.size > 25 * 1024 * 1024) { $$('[data-upmsg]', r).forEach(function (n) { n.textContent = T.tUpBig; }); return; }
      var local = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        $$('[data-uprev]', r).forEach(function (p) { p.hidden = false; $('[data-upimg]', p).src = local; $('[data-upname]', p).textContent = file.name; $('[data-updim]', p).textContent = im.naturalWidth + ' × ' + im.naturalHeight + ' px'; $('[data-upstate]', p).textContent = '…'; });
        fetch(epUp, { method: 'POST', headers: { 'Content-Type': file.type }, body: file })
          .then(function (x) { return x.json().then(function (j) { return { ok: x.ok, j: j }; }); })
          .then(function (o) {
            if (!o.ok || !o.j.url) throw o.j || {};
            st.img = { url: o.j.url, w: im.naturalWidth, h: im.naturalHeight }; st.cur = 'up'; st.prompt = '';
            $$('[data-upstate]', r).forEach(function (n) { n.textContent = T.tUpOk; });
            applyImage(); qual();
          })
          .catch(function () { $$('[data-upstate]', r).forEach(function (n) { n.textContent = ''; }); $$('[data-upmsg]', r).forEach(function (n) { n.textContent = T.tUpFail; }); });
      };
      im.onerror = function () { $$('[data-upmsg]', r).forEach(function (n) { n.textContent = T.tUpType; }); };
      im.src = local;
    }
    $$('[data-file]', r).forEach(function (f) { f.addEventListener('change', function () { handle(f.files && f.files[0]); }); });
    $$('[data-drop]', r).forEach(function (d) {
      ['dragenter', 'dragover'].forEach(function (ev) { d.addEventListener(ev, function (e) { e.preventDefault(); d.classList.add('over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { d.addEventListener(ev, function (e) { e.preventDefault(); d.classList.remove('over'); }); });
      d.addEventListener('drop', function (e) { handle(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    });
    function applyImage() {
      if (!st.img || st.cur !== 'up') return;
      if (st.line === 'falikep') { if (r.__setImg) r.__setImg(st.img.url); }
      else { st.wallImg = st.img.url; wallUp(); }
    }

    // ---------- resolution check and gate ----------
    function qual() {
      $$('.sp-q', r).forEach(function (n) { n.remove(); });
      r.__block = false; r.__wblock = false;
      if (!st.img || st.cur !== 'up') { if (r.__up) r.__up(); wallUp(); return; }
      var dpi, host;
      if (st.line === 'falikep') {
        var s = $('input.dz-size:checked', r), d = DIM[s ? s.value : 'M'];
        var imgL = Math.max(st.img.w, st.img.h), imgS = Math.min(st.img.w, st.img.h);
        dpi = Math.round(Math.min(imgL / (Math.max(d[0], d[1]) / 2.54), imgS / (Math.min(d[0], d[1]) / 2.54)));
        host = $('.sp-price', pArt);
      } else if (st.line === 'fototapeta') {
        var w = parseFloat($('[data-mw]', pWall).value), h = parseFloat($('[data-mh]', pWall).value);
        host = $('.sp-wsum', $('[data-sub=mural]', pWall));
        if (!(w >= 20) || !(h >= 20)) { wallUp(); return; }
        dpi = Math.round(Math.min(st.img.w / (w / 2.54), st.img.h / (h / 2.54)));
      } else {
        dpi = Math.round(st.img.w / (tileCm / 2.54)); host = $('.sp-wsum', $('[data-sub=paper]', pWall));
      }
      var msg, cls = '';
      if (dpi < 40) { msg = T.tUpMin; cls = 'bad'; } else if (dpi < 100) { msg = T.tUpFix; cls = 'warn'; } else { msg = dpi >= 200 ? T.tQGood : T.tQMid; }
      var p = document.createElement('p'); p.className = 'sp-q ' + cls;
      p.innerHTML = T.tQLbl + ': <b></b><br><span></span>'; p.querySelector('b').textContent = '~' + dpi + ' DPI'; p.querySelector('span').textContent = msg;
      if (host) host.insertAdjacentElement('afterend', p);
      if (st.line === 'falikep') r.__block = dpi < 40; else r.__wblock = dpi < 40;
      if (r.__up) r.__up(); wallUp();
    }
    $$('[data-tile] [data-cm]', pWall).forEach(function (b) {
      b.addEventListener('click', function () {
        tileCm = +b.dataset.cm;
        if (mock) mock.dataset.tile = tileCm;
        $$('[data-tile] [data-cm]', pWall).forEach(function (x) { x.classList.toggle('on', x === b); });
        qual();
      });
    });
    $$('input.dz-size', r).forEach(function (i) { i.addEventListener('change', qual); });
    show();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
